var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contract-production-tracking" }, [
    _c("h3", [_vm._v("生产跟踪")]),
    _vm._v(" "),
    _vm.imesLogList.length > 0
      ? _c(
          "div",
          { staticClass: "imes-log-section" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%", "font-size": "13px" },
                attrs: {
                  data: _vm.imesLogList,
                  size: "small",
                  border: "",
                  "header-cell-style": {
                    backgroundColor: "#e8eaed",
                    color: "#333",
                    fontWeight: "bold",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "序号",
                    width: "60",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "nodeStatus",
                    label: "流程节点",
                    "min-width": "150",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "createdTime",
                    label: "操作时间",
                    "min-width": "180",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }